import styled, { css } from "styled-components";

const MixInput = css`
  outline: none;
  width: 100%;
  height: 3rem;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: ${({ theme }) => theme.font.small};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.transparentPrimary};
  margin: 0.75rem 0;
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    cursor: pointer;
  }
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid lightgray;
  padding: 2rem;
  background: white;
  border-radius: 0.5rem;
`;

export const Input = styled.input`
  ${MixInput}
  ${({ holder }) => (holder ? "color: gray;" : "")}
`;


export const Select = styled.select`
  ${MixInput}
`;

export const TextArea = styled.textarea`
  ${MixInput}
  height: 10rem;
  resize: none;
`;